import Button from 'antd/lib/button';
import { useTranslation } from 'react-i18next';
import { CHINESE_SYMBOL, ENGLISH_SYMBOL } from 'i18n';
// import { localStorageService } from 'utils/LocalStorageService';
import { sessionStorageService } from 'utils/SessionStorageService';
import './LanguageSelector.less';
import { Space } from 'antd';
import { BravoGlobeIcon } from './styledComponents';

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = async () => {
    let nextLang = '';
    if (i18n.language == ENGLISH_SYMBOL) {
      nextLang = CHINESE_SYMBOL;
    } else {
      nextLang = ENGLISH_SYMBOL;
    }

    await i18n.changeLanguage(nextLang);
    sessionStorageService.set('i18nLanguage', nextLang);
  };
  return (
    <>
      <Space align="center" size={4} style={{ height: '20px', lineHeight: '20px', marginTop: '39.5px' }}>
        <Button shape="round" icon={<BravoGlobeIcon />} size="middle" onClick={changeLanguage}>
          {t('header.changeLocale')}
        </Button>
      </Space>
    </>
  );
};

export default LanguageSelector;
